export default "__VITE_ASSET__BVpmBlM8__";